export default {
  items: [
    
    {
      link: "/admin/account",
      resource: "partners",
      text: "Account",
      icon: "briefcase"
    },
    {
      link: "/admin/billing",
      resource: "partners/billing",
      text: "Billing",
      icon: "pound-sign"
    },
    {
      link: "/admin/users",
      resource: "partners/users",
      text: "Users",
      icon: "users"
    }
  ],
  header: {
    title: "Org Menu",
    show: true
  },
  hidden: true
}